import React from "react";
import { motion } from "framer-motion";
import { FaFish, FaSmile, FaLeaf, FaUserFriends, FaChild, FaGift } from "react-icons/fa";

const BENEFITS = [
  {
    icon: <FaFish className="text-blue-500 text-4xl mb-2" />,
    title: "Acuarios para Todos",
    desc: "Desde principiantes hasta expertos, tenemos productos y peces ideales para cada nivel."
  },
  {
    icon: <FaSmile className="text-yellow-500 text-4xl mb-2" />,
    title: "Relajación y Bienestar",
    desc: "Tener un acuario reduce el estrés y brinda armonía visual a tu hogar u oficina."
  },
  {
    icon: <FaLeaf className="text-green-500 text-4xl mb-2" />,
    title: "Ecosistemas Saludables",
    desc: "Te asesoramos para que tus peces vivan en un entorno sano, limpio y natural."
  },
  {
    icon: <FaUserFriends className="text-purple-500 text-4xl mb-2" />,
    title: "Comunidad Atlantis",
    desc: "Únete a nuestra comunidad: comparte experiencias, aprende y haz nuevos amigos."
  },
  {
    icon: <FaChild className="text-pink-400 text-4xl mb-2" />,
    title: "Para Todas las Edades",
    desc: "Un acuario es ideal para niños y adultos. Perfecto para enseñar responsabilidad y admirar la naturaleza."
  },
  {
    icon: <FaGift className="text-red-400 text-4xl mb-2" />,
    title: "Regalos Únicos",
    desc: "Sorprende a alguien especial con un acuario o kit de inicio personalizado."
  },
];

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12 }
  })
};

const BenefitsSection = () => (
  <motion.section
    className="container mx-auto py-12"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center">Beneficios de tener tu acuario</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
      {BENEFITS.map((benefit, i) => (
        <motion.div
          key={i}
          className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center border hover:shadow-2xl transition-all"
          custom={i}
          variants={fadeIn}
          whileHover={{ scale: 1.05 }}
        >
          {benefit.icon}
          <div className="font-bold text-lg text-blue-900 mb-2">{benefit.title}</div>
          <div className="text-gray-500">{benefit.desc}</div>
        </motion.div>
      ))}
    </div>
  </motion.section>
);

export default BenefitsSection;
